import { FcTabOnglet } from '../classe/maClasse';
import { Rank } from '../classe/classeRank';
import { AvatarMedia } from '../avatar/avatarList.def';

export enum BOARD_NAME {
  classe = 'Classe',
  national = 'National',
  niveau = 'Niveau',
  academie = 'Académie'
}
export type LeaderBoardCategories = keyof typeof BOARD_NAME;

export const leaderBoardFields: {
  [k in LeaderBoardCategories]: FcTabOnglet;
} = {
  classe: {
    name: BOARD_NAME.classe,
    title: 'Classement de ma classe',
    img: 'CarteCadeau'
  },
  academie: {
    name: BOARD_NAME.academie,
    title: 'Classement de mon académie',
    img: 'AirPods'
  },
  niveau: {
    name: BOARD_NAME.niveau,
    title: 'Classement par niveau',
    img: 'AirPodsPro'
  },
  national: {
    name: BOARD_NAME.national,
    title: 'Classement national',
    img: 'Iphone'
  }
};

export interface GetLeadersQuery {
  getClassement: GetClassement[];
}

export type MyPositions = {
  classeRank?: number;
  academieRank?: number;
  nationalRank?: number;
  niveauRank?: number;
};

export interface UserPosition {
  rank: Rank;
  firstname: string;
  lastname: string;
  moyennegenerale: number;
  ville: string;
  avatar?: AvatarMedia;
  username?: string;
}

export interface GetClassement extends UserPosition {
  elId: string;
}

export type Positions = { [k in LeaderBoardCategories]: UserPosition };
